module.exports = {
  api_route: "https://api.dashboard.delistedstocks.in",
  token:
    "7dc8e19bd89d01fae75abdbc375aae419044ab2075692ffa96f47ff320fc7393a1d9079cb7a604b67d288738e1986c0e0aaf0fb07181d8a99c0819413d6146eb3fd5491ab7a76296fcb6121fec03ef63548ce97c0acbfe069e45bb939e9ad49b8ff7d2a20c27914362448ff9098bc855b2f792f41ca1103352b8607ff0807c01579002edc34b11c0bbcc0be3b3f34e19601cd2b2b625481e89b5889777376a15022ed24783e5c06c7d21b70151274bcf33b46214e97bc1c843f6740702a8f6853603c82fc732e25329cc1e3c58dd3148624a64283243fccc446c1d4d5e9369793f96e7c8c81a97b1bf108f3e",
};

// https://api.dashboard.delistedstocks.in
// http://localhost:3003
